<template>
  <div v-if="lam.agentid && lam.stagetypeid && lam.statetypeid">
    <div>
      <h3 class="ut-text-lg ut-mb-4">Information</h3>
      <div class="property-warning-info" v-if="lead.propertyowner == 0 && lead.propertyownername">
        <img src="@/assets/images/info.svg" alt="" />
        The owner of the Property is <span class="ut-font-bold">{{lead.propertyownername}}</span>
        <span v-if="lead.propertyownerrelationship">
          , {{lead.firstname | titleCase }}'s {{lead.propertyownerrelationship}}
        </span>
      </div>
      <div class="property-warning-info"
        v-if="!!contactpreferences
          && ((contactpreferences.contacttimecontextid != '0'
            && contactpreferences.contacttimeconstraint == '1')
          || (contactpreferences.contactdatecontextid != '0'
            && contactpreferences.contactdateconstraint == '1' ))">
        <img src="@/assets/images/info.svg" alt="" />
        The vendor is expecting a call
        <span v-if="contactpreferences.contacttimecontextid == '1'">
          before {{contactpreferences.contacttimestart}} </span>
        <span v-if="contactpreferences.contacttimecontextid == '2'">
          after {{contactpreferences.contacttimestart}} </span>
        <span v-if="contactpreferences.contacttimecontextid == '3'">
          at {{contactpreferences.contacttimestart}} </span>
        <span v-if="contactpreferences.contacttimecontextid == '4'">
          between {{contactpreferences.contacttimestart}} and {{contactpreferences.contacttimeend}}</span>
        <span
          v-if="contactpreferences.contactdatecontextid == '1'
            && contactpreferences.contactdateconstraint != '0'"> on {{contactpreferences.contactstartdate | formatDate("D MMM YYYY")}}
        </span>
        <span v-if="contactpreferences.contactdatecontextid == '2' && contactpreferences.contactdateconstraint != '0'">
           before {{contactpreferences.contactstartdate | formatDate("D MMM YYYY")}}
        </span>
        <span v-if="contactpreferences.contactdatecontextid == '3' && contactpreferences.contactdateconstraint != '0'">
           after {{contactpreferences.contactstartdate | formatDate("D MMM YYYY")}}
        </span>
      </div>

      <div class="property-warning-info" v-if="lead.listingstatus == `Currently Listed`">
        <img src="@/assets/images/info.svg" alt="" />
        This property is currently listed with an agent and the exclusivity ends in {{lead.exclusivityperiodexpiry}}. The vendor is looking for other agents.
      </div>

      <div class="ut-mt-4">
        <div class="property-info">
          <div class="img-wrapper">
            <!-- <img src="@/assets/styles/frontend-library/images/icon-house.svg" alt="" /> -->
            <svg-icon :icon="'icon-house'"
                      :size="20"
                      :addClass="''"></svg-icon>
          </div>
          <div class="property-info-text">
            <h3>PROPERTY</h3>
            <p>
              {{ propertyType }} <span v-if="lead.listingstatus && lead.listingstatus !== `Currently Listed`">{{lead.listingstatus | stringSeparator}}</span>
            </p>
          </div>
        </div>
        <div class="property-info">
          <div class="img-wrapper">
            <img src="@/assets/images/goal.svg" alt="" />
          </div>
          <div class="property-info-text">
            <h3>GOAL</h3>
            <p>
              {{ lead.expecttosell | stringSeparator('Sell in') }} {{ expectSalePrice | stringSeparator}} {{lead.vendoridealsaleoutcome | stringSeparator}}
            </p>
          </div>
        </div>
        <div class="property-info">
          <div class="img-wrapper">
            <img src="@/assets/images/motivation.svg" alt="" />
          </div>
          <div class="property-info-text">
            <h3>MOTIVATION</h3>
            <p>{{lead.reasonforsale}} {{motivation | stringSeparator}}</p>
          </div>
        </div>
      </div>
    </div>

    <div
      class="ut-mt-10 ut-text-green-400 hover:ut-underline ut-cursor-pointer"
      v-if="!showMore"
      v-gaEvent="{
        category: 'Agent Referral',
        action: 'Review vendor and property details - view more info',
        label: gaLabel
      }"
      v-on:click="showDetail" >
        view more info
    </div>

    <div class="ut-mt-10" v-if="showMore && allListing.length">
      <core-logic-history :listingHistory="allListing" :limit="4" />
    </div>

    <div class="ut-mt-10" v-if="showMore && images.length">
      <property-photos :images="images" :propertyAddressId="lead.propertyaddressid" />
    </div>

    <div class="ut-mt-10" v-if="showMore && lead.latitude"
      style="padding-right: 2rem;">
      <h3 class="ut-text-lg ut-mb-4">Location</h3>
      <google-map
        name="name"
        :enableMarkers="true"
        :enableRadius="false"
        :enableMapControls="true"
        :markersInfo="[
          {
            latitude: lead.latitude,
            longitude: lead.longitude
          }
        ]" />
    </div>
    <div class="ut-mt-10 ut-mb-10" v-if="showMore && coreLogicId">
        <a :href="'https://rpp.rpdata.com/rpp/property/detail.html?propertyId=' + coreLogicId"
          target="_blank" class="btn btn-small ut-border-green-400 ut-text-green-400">
          Open in Corelogic RP Pro
        </a>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import PropertyPhotos from '@/components/PropertyPhotos.vue';
import GoogleMap from '@/components/GoogleMap.vue';
import CoreLogicHistory from '@/components/CoreLogicHistory.vue';
import SvgIcon from '@/components/SvgIcon.vue';

export default {
  name: 'PropertyDetails',
  components: {
    CoreLogicHistory,
    PropertyPhotos,
    GoogleMap,
    SvgIcon,
  },
  data() {
    return {
      reasonForSale: [
        'Relocating',
        'Upsizing',
        'Downsizing',
        'Family Situation',
      ],
      showMore: false,
      images: [],
      loadingPhotos: true,
      coreLogicId: null,
      allListing: [],
    };
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      lam: state => state.leadAgentMappingStore.lam,
      contactpreferences: state => state.leadAgentMappingStore.contactpreferences,
      lead: state => state.leadAgentMappingStore.lead,
    }),
    gaLabel() {
      return `AID=${this.lam.agentid} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
      // return `AID=${this.agent.id} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
    },
    propertyType() {
      let propertybeds = '';
      let propertytype = '';
      if (this.lead.beds == '0') {
        propertybeds = '';
        propertytype = 'Studio';
      } else {
        if (this.lead.beds) {
          propertybeds = `${this.lead.beds}br`;
        }
        if (this.lead.propertytype) {
          propertytype = this.lead.propertytype;
        }
      }
      return `${propertybeds} ${propertytype}`;
    },
    expectSalePrice() {
      let str = '';
      if (parseInt(this.lead.expectedsalepricelow, 10) > 0
        || parseInt(this.lead.expectedsalepricehigh, 10) > 0) {
        if (this.lead.expectedsalepricelow) {
          str = `Sell for ${this.$options.filters.formatPrice(this.lead.expectedsalepricelow, '$')}`;
        }
        if (this.lead.expectedsalepricehigh) {
          str += `-${this.$options.filters.formatPrice(this.lead.expectedsalepricehigh, '$')}`;
        }
      }
      return str;
    },
    motivation() {
      let str = '';
      if (this.reasonForSale.indexOf(this.lead.reasonforsale) > -1) {
        str = this.lead.boughtanotherproperty;
      } else if (this.lead.reasonforsale === 'Deceased Estate') {
        if (this.lead.probate === 'Yes') {
          str = 'The property has been through probate';
        } else if (this.lead.probate === 'No') {
          str = 'The property has not been through probate';
        } else {
          str = 'Not sure if the property has been through probate';
        }
      } else if (this.lead.reasonforsale === 'Investment Property') {
        if (this.lead.tenanted) {
          if (this.lead.tenanted == 'Yes') {
            str = 'Tenanted';
            if (this.lead.leaseexpiration) {
              str += `, lease expires: ${this.lead.leaseexpiration}`;
            }
            if (this.lead.propertymanager === 'Yes') {
              str += ', vendor has a property manager';
            }
          } else {
            str = 'Not tenanted';
          }
        } else {
          str = '';
        }
      } else {
        str = '';
      }
      return str;
    },
  },
  methods: {
    getListingData(soldDate, listingType, listingInfo, listingAgency) {
      return {
        sortBy: this.$helpers.formatDateNormal(soldDate),
        listingType,
        listingInfo,
        listingAgency,
      };
    },
    showDetail() {
      const propertyAddressId = this.lead.propertyaddressid;
      try {
        this.$apiServices.oa.propertyAddress.getById(propertyAddressId)
          .then((propertyAddressData) => {
            if (propertyAddressData.rpdataid) {
              const clData = {
                include: 'forRentPropertyCampaignList,forSalePropertyCampaignList',
              };
              this.coreLogicId = propertyAddressData.rpdataid;
              this.$apiServices.cl.property.getById(propertyAddressData.rpdataid, clData)
                .then((propertyData) => {
                  if (propertyData) {
                    const {
                      photos, sales, listings, rentcampaigns,
                    } = propertyData;

                    sales.forEach((sale) => {
                      this.allListing.push(
                        this.getListingData(sale.solddate, 'sale', `Sold for $${this.$options.filters.formatPrice(sale.soldprice)}`, sale.listingagency),
                      );
                    });

                    rentcampaigns.forEach((campaign) => {
                      this.allListing.push(
                        this.getListingData(campaign.fromDate, 'rent', `Leased at $${this.$options.filters.formatPrice(campaign.price)} p/${campaign.period.toLowerCase()}`, campaign.agencyname),
                      );
                    });

                    this.allListing = this.allListing.sort(this.$helpers.sortByDate);

                    // console.log(this.allListing);

                    if (photos.length) {
                      this.loadingPhotos = false;
                      // this.propertyPhotos = photos;

                      photos.forEach((image) => {
                        this.images.push(image.large);
                      });
                    }
                  }
                });
            }
          });
      } catch (e) {

      } finally {
        this.showMore = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.property-warning-info{
    @apply ut-p-4 ut-mb-3 ut-text-sm;
    background-color: #fef7e3;
    border-radius: 3px;
    img {
        @apply ut-mr-3 ut-float-left;
        width: 20px;
        vertical-align: middle;
    }
}
.property-info{
    @apply ut-mb-4 ut-flex ut-mt-8;
    .img-wrapper {
        @apply ut-bg-green-400 ut-mr-4 ut-ml-0;
        padding: 8px 10px;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        min-width: 40px;
        color: #ffffff;
        img {
            width: 20px;
            vertical-align: middle;
        }
    }
    h3 {
      @apply ut-text-xs ut-font-bold ;
      letter-spacing: 1.25px;
      line-height: 20px;
    }
    .property-info-text {
        @apply ut-m-0;
        p{
            @apply ut-text-sm ut-opacity-75;
        }
    }
}
</style>
